import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { observer } from 'mobx-react-lite';
import {
  Button,
  Icon,
  IconButton,
  NoItemsBox,
} from '../../../../../../components';
import Rules from '../store/Rules';

export default observer(function ListRules({ rules }: { rules: Rules }) {
  if (rules.isEmpty) {
    return <NoItemsBox itemsName="rules" sx={{ mt: 0 }} />;
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Instruction</TableCell>
            <TableCell>From</TableCell>
            <TableCell>To</TableCell>
            <TableCell>Version</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rules.items.map((rule, index) => (
            <TableRow key={rule.id}>
              <TableCell scope="row">
                {rule.hasOs('win32') && <Icon icon="windows" />}
                {rule.hasOs('darwin') && <Icon icon="apple" />}
                {rule.hasOs('linux') && <Icon icon="linux" />}
                {rule.type}
              </TableCell>
              <TableCell>{rule.sourcePath}</TableCell>
              <TableCell>{rule.destinationPath}</TableCell>
              <TableCell>{rule.version || 'all'}</TableCell>
              <TableCell align="right">
                {index > 0 && (
                  <IconButton
                    icon="sort-up"
                    onClick={() => rules.moveUp(index)}
                  />
                )}

                {index < rules.items.length - 1 && (
                  <IconButton
                    icon="sort-down"
                    onClick={() => rules.moveDown(index)}
                  />
                )}

                <Button
                  icon="pen"
                  onClick={() => rules.selectRule(rule)}
                  size="small"
                  type="primaryText"
                >
                  Edit
                </Button>
                <Button
                  icon="trash"
                  onClick={() => rule.delete()}
                  size="small"
                  type="primaryText"
                >
                  Delete
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
});
